function IdentityProductActions({ product, exporting, onSaveImage }) {
  const canBuy = product.digitalOnly !== true;

  // TODO: Connect this product ID and saved customization snapshot to the physical-product checkout flow.
  return (
    <div className={`identity-product-actions ${canBuy ? "has-buy" : ""}`} aria-label={`${product.name} actions`}>
      <button type="button" disabled={exporting} onClick={onSaveImage}>
        {exporting ? "Creating..." : "Save Image"}
      </button>
      {canBuy && (
        <button type="button" className="identity-buy-button" disabled aria-disabled="true" title="Purchasing coming soon">
          <span>Buy</span>
          <small>Coming Soon</small>
        </button>
      )}
    </div>
  );
}

export default IdentityProductActions;
